import useAnalytics from '@root/shared/useAnalytics';
import { PARAMETERS } from '@root/tracking/constants';
import { AgentContact } from '@root/types';
import Card from '../Card';
import Contact from './Contact';
import s from './ContactCard.module.less';

type ContactProps = {
  contacts: AgentContact[];
  title: string;
  emailSubjectName?: string;
  sourcePage: typeof PARAMETERS.listingPage | typeof PARAMETERS.buildingPage;
};
const ContactCard = ({ title, contacts, emailSubjectName, sourcePage }: ContactProps) => {
  const { contactInteraction } = useAnalytics();
  const handleEmailContact = (contact: AgentContact, contactRanking: number) => {
    contactInteraction({
      action: PARAMETERS.contactSelectContact,
      actionType: 'CONTACT_SELECT_CONTACT',
      sourceContent: PARAMETERS.contactSection,
      sourcePage,
      otherAttributes: {
        contactRanking,
        contactInfo: {
          name: contact.name,
          role: contact.role,
          company: contact.company,
        },
        contactAvatar: contact.photoUrl ? 'yes' : 'no',
      },
    });
  };
  return contacts.length ? (
    <Card
      className={s.contactCard}
      titleClassName={s.title}
      contentClassName={s.content}
      title={title}
    >
      {contacts.map((contact, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className={s.contactContainer} key={i}>
          <Contact
            contact={contact}
            emailSubjectName={emailSubjectName}
            onContactEmailClick={() => handleEmailContact(contact, i + 1)}
            compact={false}
          />
        </div>
      ))}
    </Card>
  ) : null;
};

export default ContactCard;
